<template>
  <div class="app-container">
    <el-card class="mb5">
    <el-form
      ref="formSearch" :model="queryForm" label-position="top"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <!-- 日期 -->
          <el-form-item :label="$t('operationCenter.date')">
            <el-date-picker
              v-model="timeValue"
              :end-placeholder="$t('operationCenter.endDate')"
              :picker-options="pickerOptions"
              :start-placeholder="$t('operationCenter.startDate')"
              range-separator="~"
              style="width: 100%"
              type="daterange"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 转运中心 -->
          <el-form-item :label="$t('collectionCenter.transferCenter')">
            <el-select
              v-model="queryForm.transferCenterId"
              :placeholder="$t('GlobalSetObj.all')"
              clearable
              style="width: 100%"
            >
              <el-option label="SP-RR-001" :value="18" />
              <el-option label="SP-RR-002" :value="3140" />
              <el-option label="ANJUN" :value="90" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="margin-top: 27px">
          <div>
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('operationCenter.Procurar') }}
            </el-button>
            <el-button icon="el-icon-refresh-left" size="small" @click="resetForm">
              {{ $t('operationCenter.reset') }}
            </el-button>
            <el-button
              icon="el-icon-upload2"
              size="small"
              style="margin-bottom: 10px"
              type="primary"
              @click="allExportOrder"
            >{{ $t('newOrder.export') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    </el-card>
    <el-card>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="(item, ind) in tableHeaderList"
        :key="ind"
        :align="item.align"
        :label="item.label"
        :min-width="item.width"
        :prop="item.prop"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'transferCenterName'">
            {{ scope.row[item.prop] || '--' }}
          </div>
          <div v-else>{{ scope.row[item.prop] || '0' }}</div>
        </template>
      </el-table-column>
    </el-table>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList';
import { sortingTimelinessExport, sortingTimelinessPage } from '@/api/newExpressAPI';

export default {
  name: 'ReturnDataMonitoring',
  data() {
    return {
      queryForm: {
        transferCenterId: null
      },
      tableData: [],
      tableHeaderList: [
        // 日期
        { label: this.$t('uploadFile.date'), prop: 'dataDate', width: 100 },
        // 转运中心
        { label: this.$t('collectionCenter.transferCenter'), prop: 'transferCenterName', width: 140 },
        // 入库票数
        {
          label: this.$t('mdfeTranslate.inboundTicketCount'),
          prop: 'warehousingCount',
          width: 150
        },
        // 及时分拣票数
        {
          label: this.$t('mdfeTranslate.timelySortingTickets'),
          prop: 'timelySortingCount',
          width: 150
        },
        // 分拣及时率
        {
          label: this.$t('mdfeTranslate.sortingTimelyRate'),
          prop: 'sortingTimelinessStr',
          width: 160
        }
      ],
      timeValue: [this.getAWeek().startDate, this.getAWeek().endDate],
      selectDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      }
    };
  },
  created() {
    this.getSearch();
  },
  methods: {
    // 查询条件整理
    queryParam() {
      const params = {
        startDate: null,
        endDate: null,
        transferCenterId: this.queryForm.transferCenterId
      };
      if (this.timeValue && this.timeValue.length > 0) {
        params.startDate = this.timeValue[0];
        params.endDate = this.timeValue[1];
      }
      return params;
    },
    // 获取加盟商时效统计列表
    getSearch() {
      const data = this.queryParam();
      if (!this.timeValue || this.timeValue.length === 0) {
        this.$message.warning(this.$t('fixDutyFine.selectTimeRange'));
        return;
      }
      sortingTimelinessPage(data).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data;
        }
      });
    },
    enterSearch() {
      this.getSearch();
    },
    // 搜索、重置
    resetForm() {
      this.timeValue = [this.getAWeek().startDate, this.getAWeek().endDate];
      this.queryForm.transferCenterId = null;
      this.getSearch();
    },
    allExportOrder() {
      if (!this.timeValue || this.timeValue.length === 0) {
        this.$message.warning(this.$t('fixDutyFine.selectTimeRange'));
        return;
      }
      const data = this.queryParam();
      sortingTimelinessExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 获取最近30天时间
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD')
      };
    }
  }
};
</script>

<style scoped>
.app-container >>> .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}

.table-active {
  color: #00A551;
  cursor: pointer;
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}
</style>
